import {DocumentFile} from "./document-file";
import {DocumentStatus} from "./documentStatus";
import {DocumentFolder} from "./documentFolder";
import {DocumentClass} from "./documentClass";
import {SubInformation} from "./subInformation";
import {DocumentCompletionStatus} from "./documentCompletionStatus";
import {Service} from "./service";
import {AdditionalConstructionFileData} from "./additionalConstructionFileData";
import {AdditionalCertificateData} from "./additionalCertificateData";

export class Document {

    constructor(name : string, information : string = undefined) {
        this.docname = name;
        this.information = information;
        this.received = false;
        this.requested = false;
    }

    docid: string;
    docname: string;
    received: Boolean;
    requested: Boolean;
    information: string;
    partDescription: string;
    docfullname: String;
    files: Array<DocumentFile> = [];
    statusInformation: Array<DocumentStatus> = [];
    folders: Array<DocumentFolder> = [];
    subInformations: Array<SubInformation> = [];
    documentClass: DocumentClass
    completionStatus: DocumentCompletionStatus;
    selectedServices: Service[] = [];
    numberOfFolders: number;
    // Boolean used in the frontend to be able to determine per document if its corresponding files and folders are still loading
    isLoadingFilesAndFolder: boolean;
    expectedResponseDate: Date;
    additionalConstructionFileData: AdditionalConstructionFileData;
    additionalCertificateData: AdditionalCertificateData;


    size(onlyNew) {
        let size = 0;
        this.files.forEach(function (file) {
            if (onlyNew && file.downloaded) {
                return;
            }
            size += file.length;

        })
        return size;
    }
}
